// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1xNB0","info":"Note_info__2bJ4P","note":"Note_note__2W-0y","actions":"Note_actions__rUbaZ"};